import angular from "angular"

import "./layout.component.css"
const templateUrl = require("ngtemplate-loader!html-loader!./layout.component.html")

LayoutController.$inject = [
  "$scope",
  "$rootScope",
  "appRoutesService",
  "loginService",
  "PeriodoService",
  "store",
  "UserFlagService"
]
function LayoutController(
  $scope,
  $rootScope,
  appRoutesService,
  loginService,
  PeriodoService,
  store,
  UserFlagService
) {
  var self = this
  self.searchActive = false

  self.periodo_activo = null

  self.username = loginService.getUser()

  self.activeRoute = appRoutesService.getActiveRoute()
  self.institution_code = store.get("user").institution_code || ""

  self.show_igs_logo = self.institution_code == "igs.cl"
  self.show_upv_logo = self.institution_code == "uda.cl"
  self.show_upb_logo = self.institution_code == "upb.co"
  self.show_demo_logo = self.institution_code == "demo.foris"

  self.dashboardLinks = []

  // Cada vez que cambie el periodo, recargar toda la aplicación...
  $rootScope.$on("periodoChange", function(periodo) {
    appRoutesService.reloadView()
  })

  self.periodoChange = function() {
    $rootScope.periodo_activo = self.periodo_activo

    for (var i = 0; i < self.periodos.length; i++) {
      if ("" + self.periodos[i].id === self.periodo_activo) {
        PeriodoService.set_periodo_actual(self.periodos[i])
        break
      }
    }
  }

  self.toggleSearchBar = function() {
    self.searchActive = !self.searchActive
  }

  self.irAListaAlumnos = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAListaAlumnos()
  }

  self.irAUsuario = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAUsuario()
  }

  self.irAAtenciones = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAAtenciones()
  }

  self.irAAdmin = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAAdmin()
  }

  self.irAAyuda = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAAyuda()
  }

  self.irAReportes = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAReportes()
  }

  self.irAHome = function() {
    if (self.searchActive) {
      self.toggleSearchBar()
    }
    appRoutesService.irAHome()
  }

  self.logout = function() {
    loginService.logout()
  }

  self.usuarioGet = function() {
    usuarioService.getUser().then(function(data) {
      console.log(data)
    })
  }

  self.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev)
  }

  $scope.$on("route-changed", function(newRoute) {
    self.activeRoute = appRoutesService.getActiveRoute()
  })

  self.$onInit = function() {
    // Obtener todos los periodos
    PeriodoService.get(function(data) {
      self.periodos = data.results
    })

    // Obtener el periodo actual
    PeriodoService.get_periodo_actual().then(function(periodo_activo) {
      self.periodo_activo = "" + periodo_activo.id
      $rootScope.periodo_activo = self.periodo_activo
    })

    UserFlagService.getIdentityUserDetails().then(function(data) {
      const suiteUrl = SUITE_URL
        ? SUITE_URL.endsWith("/")
          ? SUITE_URL.slice(0, -1)
          : SUITE_URL
        : null

      const dashboardLinks = [
        {
          name: "Estrategico",
          url: `${suiteUrl}/stella/dashboard/strategic`,
          permissions: ["mops:stella-dashboard-strategic:view"]
        },
        {
          name: "Operativo",
          url: `${suiteUrl}/stella/dashboard/operational`,
          permissions: ["mops:stella-dashboard-operational:view"]
        },
        {
          name: "Tactico",
          url: `${suiteUrl}/stella/dashboard/tactical`,
          permissions: ["mops:stella-dashboard-tactical:view"]
        },
        {
          name: "Administrativo",
          url: `${suiteUrl}/stella/dashboard/administrative`,
          permissions: ["mops:stella-dashboard-administrative:view"]
        }
      ]

      self.dashboardLinks =
        SUITE_URL && data
          ? dashboardLinks.filter(link =>
              (data.data.data.me.permissions || []).some(permission =>
                link.permissions.includes(permission)
              )
            )
          : []
    })
  }
}

angular.module("appModule").component("layout", {
  templateUrl: templateUrl,
  controller: LayoutController
})
